function initProductGallery(clientsEl) {
  const items = clientsEl.querySelectorAll('[data-client]');
  const nextBtn = clientsEl.querySelectorAll('[data-clients-btn="next"]');
  const prevBtn = clientsEl.querySelectorAll('[data-clients-btn="prev"]');
  let currentIndex = 1;
  const totalItems = items.length;
  const scrollTo = 0;
  const isScrolling = false;

  // set image
  function setItem(index) {
    currentIndex = index;
    clientsEl.querySelectorAll('[data-client]').forEach((client) => {
      client.hidden = true;
    });
    const client = clientsEl.querySelector('[data-client="' + index + '"]');
    console.log(client);
    client.classList.add('client--next');
    setTimeout(() => {
      client.hidden = false;
    }, 100);
    setTimeout(() => {
      client.classList.remove('client--next');

      // Adjust the parent container height to match the client element height
      if (client) {
        const parent = clientsEl.querySelector('.clients__body');
        if (parent) {
          const clientHeight = client.offsetHeight;
          parent.style.height = clientHeight + 'px';
        }
      }
    }, 200);
  }

  // next button
  nextBtn.forEach((control) => {
    control.addEventListener('click', () => {
      let newIndex = currentIndex + 1;
      if (newIndex > totalItems) newIndex = 1;
      setItem(newIndex);
    });
  });

  // previous button
  prevBtn.forEach((control) => {
    control.addEventListener('click', () => {
      let newIndex = currentIndex - 1;
      if (newIndex < 1) newIndex = totalItems;
      setItem(newIndex);
    });
  });

  // initial image
  setItem(1);

  // Recalculate clients__body height on screen resize
  window.addEventListener('resize', () => {
    const activeClient = clientsEl.querySelector('[data-client]:not([hidden])');
    const parent = clientsEl.querySelector('.clients__body');
    if (activeClient && parent) {
      parent.style.height = activeClient.offsetHeight + 'px';
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const clientsEls = document.querySelectorAll('[data-clients]');

  clientsEls.forEach((clientsEl) => {
    initProductGallery(clientsEl);
  });
});
